import $, { get } from "jquery";
import React from "react";
import * as ReactDOM from 'react-dom';
import ListItem from "./components/listItem";
import SelectSearch from "react-select-search";
import NumberField from "./components/numberField";
import {generateVectorPosition} from '../../../../client/utils/vector-position'
import { goToAnchor, configureAnchors  } from 'react-scrollable-anchor'
let windowDevice=window.innerWidth;

class WidgetButtonHover extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        button: ".btn-info-dropdown",
        content_dropdown: ".offset-box-img-content--dropdown",
        option: "#listDonate",
        url_link_content_form:".offset-box-form-content--url",
        btn_readmore_content:".read-more-content",
        url_in_content:".offset-box-img-description a",
        img: ".background-img-position .img-position-item",
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $button: this.$element.find(selectors.button),
      $dropdown: this.$element.find(selectors.content_dropdown),
      $option: this.$element.find(selectors.option),
      $url_link_content_form:this.$element.find(selectors.url_link_content_form),
      $btn_readmore_content:this.$element.find(selectors.btn_readmore_content),
      $url_in_content:this.$element.find(selectors.url_in_content),
      $img: this.$element.find(selectors.img),
    };
  }

  hoverItem(dropdown,heightElement){
    // let heightElm;
    // if(heightElement){
    //   heightElm = heightElement.offsetHeight;
    // }
    if(!dropdown.hasClass("active")){
      dropdown.toggleClass( "active" );
        setTimeout(function() {
          dropdown.removeClass("opacity-0")
        },200)
    }else{
      dropdown.addClass("opacity-0")
      setTimeout(function() {
        dropdown.toggleClass( "active" );
      },200)
    }
    window.addEventListener('click',function(e){
      let btnClick = document.querySelector('.btn-info-dropdown i');
      let contentDropdown = document.querySelector('.content-dropdown-container p');
      if(e.target.matches('.btn-info-dropdown i')==false && e.target.matches('.content-dropdown-container p')==false){
        dropdown.addClass("opacity-0")
        setTimeout(function() {
          dropdown.removeClass('active');
        },200)
      }
    })
  }
  bindEvents() {
    let button = this.elements.$button[0];
    let dropdown = this.elements.$dropdown[0];
    let option = this.elements.$option[0];
    let img_abs = this.elements.$img;
    let url_link_content_form = this.elements.$url_link_content_form[0];
    let btn_readmore_content =  $(this.elements.$btn_readmore_content[0]);
    let dropdownItem = $(dropdown);
    let heightElement = document.querySelector('.content-dropdown-container');
    let contentDonate = $('.offset-box-form-content--container');
    let heightContentDonate = document.querySelector('.offset-box-form-content--container .content');
    let list_url_incontent =  $(this.elements.$url_in_content);
    img_abs =  Array.prototype.slice.call(img_abs);
    if(img_abs.length!=0) {
      img_abs.forEach(item => {
        let dataPosition = item.getAttribute('data-position');
        let dataResponsive = item.getAttribute('data-responsive');
        let defaultObj = JSON.parse(atob(dataPosition))
        let responsive = JSON.parse(atob(dataResponsive))
        generateVectorPosition(defaultObj, responsive, item);
    });
  }
    if(button){
      
        if(windowDevice > 1024){
          $(button).hover(() =>{
            this.hoverItem(dropdownItem,heightElement)
          });
        }else{
          $(button).click(() =>{
            this.hoverItem(dropdownItem,heightElement)
          });
        }
        // $( window ).resize(function() {
        //   let widthResize = window.innerWidth;
        //   if(widthResize >= 1024){
        //     $(button).hover(this.hoverItem(dropdownItem,heightElement));
        //   }else{
        //     $(button).click(() =>{
        //       this.hoverItem(dropdownItem,heightElement)
        //     });
        //   }
        // });
    }
    if(url_link_content_form){
      let offsetContainerForm = document.querySelector(".offset-box-form-container");
      let offsetFormContent = document.querySelector(".offset-box-form-content");
      if(windowDevice <= 996){
        offsetContainerForm.appendChild(url_link_content_form);
      } else{
        offsetFormContent.appendChild(url_link_content_form);
      }
      $( window ).resize(function() {
        let widthResize = window.innerWidth;
        if(widthResize <= 996){
          offsetContainerForm.appendChild(url_link_content_form);
        }else{
          offsetFormContent.appendChild(url_link_content_form);
        }
      });
    }
    if(btn_readmore_content.length){
      let offSetTopDropdown =  btn_readmore_content.offset().top;
      btn_readmore_content.click(()=>{
        if(btn_readmore_content.text()=="Read less"){
          window.scrollTo({
            top: offSetTopDropdown - 200,
            behavior: 'smooth'
          });
          btn_readmore_content.text("Read more");
          btn_readmore_content.removeClass("more");
        } else{
          btn_readmore_content.text("Read less");
          btn_readmore_content.addClass("more");
        }
        this.hoverItem(contentDonate,heightContentDonate)
      })
        
    }
    list_url_incontent.length !=0 && (
      list_url_incontent.each(function(){
        if(!$(this).hasClass('ecf-link')){
          $(this).addClass('ecf-link')
        }
      })
    )
    // REACT BUILD //
    if(option){
      const DATA = JSON.parse(atob(option.getAttribute('data')));
      ReactDOM.render(
        <App data={DATA} />,
        option
      );
    }
  }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetButtonHover, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_offset_content_box.default",
    addHandler
  );
});

class App extends React.Component {

	constructor(props){
		super(props);
    let data = props;
		let {options} = props.data;
    let {dataOption} = props.data;
    Object.defineProperty(window, 'localStorage', { value: global.localStorage,configurable:true,enumerable:true,writable:true });

		this.state = {
      data : data,
      options : options,
      dataOption : dataOption,
      dataBack:
        {
          moneyState: 0,
          hasProgram: false,
          money: '',
          program: '',
          error: {}
        }
		}
	}

  componentDidMount() {
    // let {dataBack} = this.state;
    // let localData = this.getLocalStorage('how-to-donate-form');

    // this.setState({
    //   dataBack: {
    //     ...dataBack,
    //     moneyState: localData['moneyState'] !== '' ? localData['moneyState'] : '',
    //     money: localData['money'] || '',
    //     program: localData['program'] || '',
    //     hasProgram: localData['program'] != null && localData['program'] !== ''
    //   }
    // })
  }

  handleMoneyChange = (value)  => {
    let {dataBack} = this.state;
    
    if(value != '') {
      delete dataBack['error']['money'];
    }

    this.setState({
      dataBack: {
        ...dataBack,
        money: value
      },
    });
  }

  handleProgrammeCheckbox = (event) =>{
      let isChecked = event.target.checked;
      let selector = document.getElementById('selector');
      selector.classList.remove("show");
      if(isChecked) {
        selector.classList.add("show");
        this.setState({
          dataBack: {
            ...this.state.dataBack,
            hasProgram: true
          },
        });
      }else{
        let {dataBack} = this.state;
        delete dataBack['error']['program'];

        this.setState({
          dataBack: {
            ...dataBack,
            program: "",
            hasProgram: false
          },
        });
      }
  }
  getDataMoney = (value, index) => {
    let {dataBack} = this.state;
    
    if(value != '') {
      delete dataBack['error']['money'];
    }
    
    this.setState({
      dataBack: {
        ...dataBack,
        money: value,
        moneyState: index != '' && Number(index)
      },
    })
  }

  handleProgrammeChange = (value) =>{
    let checkSelected = document.getElementById('selector');
    checkSelected.classList.remove("selected")
    if(value){
      checkSelected.classList.add("selected")
    }
    let findProgram = this.state.dataOption.find(item => item.value === value)
    
    let {dataBack} = this.state;
    delete dataBack['error']['program'];

    this.setState({
      dataBack: {
        ...dataBack,
        program: findProgram.value,
      },
    });
  }

  saveLocalStorage(array, nameArray) {    
    localStorage.removeItem(nameArray);    
    var jsonData = JSON.stringify(array);    
    localStorage.setItem(nameArray, jsonData);
  }

  getLocalStorage(nameArray) {    
    var jsonData = localStorage.getItem(nameArray);

    if (!jsonData) { 
      return {}; 
    }

    return JSON.parse(jsonData);
  }
  
  getAllData = () => {
    configureAnchors({offset: -150, scrollDuration: 1000})
    goToAnchor('donateFormHowTo', true)
    if(this.validate()) return;
    let getProgram = document.querySelector("#selector .select-search input");
    let getDataProgram = getProgram.value;
    let {money, program, moneyState} = this.state.dataBack;

    this.setState({
      dataBack: {
        ...this.state.dataBack,
        program: getDataProgram,
      },
    })
    this.saveLocalStorage({money, program, moneyState}, "how-to-donate-form")
    location.href=`${JSON.parse(atob(apiObject)).homeUrl}/donate/?amount=${money}&programme=programme-${program}/`;
  }

  validate = () => {
    let errorId = false;
    let {dataBack} = this.state;
    let {money, program, hasProgram, moneyState} = dataBack;
    let {list_money} = this.props.data;
    let isSelectedOther = (moneyState == list_money.length);
    
    if(moneyState === '') {
      dataBack['error']['money'] = 'Please select an amount';

      !errorId && (errorId = true);
    }
    else if(isSelectedOther && money == '') {
      dataBack['error']['money'] = 'Please fill in an amount';
      
      !errorId && (errorId = true);
    }

    if(hasProgram && program == '') {
      dataBack['error']['program'] = 'Please select a programme';

      !errorId && (errorId = true);
    }

    this.setState({
      dataBack: dataBack
    })

    return errorId;
  }

  onBlurSelect = () =>{
    setTimeout(() =>{
      let errorId = false;
      let {dataBack} = this.state;
      let {program, hasProgram} = dataBack;
      if(hasProgram && program == '') {
        dataBack['error']['program'] = 'Please select a programme';

        !errorId && (errorId = true);
      }

      this.setState({
        dataBack: dataBack
      })
      return errorId;
    },100)
  }
  onBlurInput = ()  =>{
    setTimeout(() =>{
      let errorId = false;
      let {dataBack} = this.state;
      let {money, moneyState} = dataBack;
      let {list_money} = this.props.data;
      let isSelectedOther = (moneyState == list_money.length);
      if(isSelectedOther && money == '') {
        dataBack['error']['money'] = 'Please fill in an amount';

        !errorId && (errorId = true);
      }

      this.setState({
        dataBack: dataBack
      })
      return errorId;
    },100)
  }
	render() {
    let {list_money,other_amount,check_box} = this.props.data;
    let {title_btn, description_form} = this.state.options;
    let {data, dataBack} = this.state;
    let {money, error, moneyState, program, hasProgram} = dataBack;
    let classOtherActive = (list_money.length === moneyState) ? ' active' : '';
    let classOtherMoneyFocus = (list_money.length === moneyState) ? ' focus' : '';
    let classProgrammeActive = hasProgram ? ' show' : '';
    let {label} = other_amount
		return (
			<div className="ecf-box-donate" id="donateFormHowTo" >
        <div className="ecf-box-donate__title">
        Choose an amount to give
        </div>
        <div>
          <ListItem
            getDataMoney = {this.getDataMoney}
            data = {data}
            moneyState = {moneyState}
          />
          <div className={'ecf-box-donate__item-price-list-other' + classOtherActive}>
                <label htmlFor="donatedSpecific">
                    <span className="label">
                        {label}
                    </span>
                    <span className="currency">
                        S$
                    </span>
                    <NumberField value={money} onChange={this.handleMoneyChange} onBlur={this.onBlurInput} />
                </label>
          </div>
          {
            error && error.money &&
              <div className="text-error">{error.money}</div>
          }
        </div>
        <div className="ecf-box-donate__check">
          <input type="checkbox" id="vehicle1" onChange={this.handleProgrammeCheckbox} checked={classProgrammeActive} />
          <label htmlFor="vehicle1">{check_box}</label>
        </div>
        <div id="selector" className={'ecf-box-donate__Selector' + classProgrammeActive}>
          <SelectSearch 
              value = ""
              options = {this.state.dataOption}
              placeholder="Choose a programme"
              onChange={e => this.handleProgrammeChange(e)}
              onBlur={this.onBlurSelect}
          />
          {
            error && error.program &&
              <div className="text-error" >{error.program}</div>
          }
        </div>
        <button onClick={this.getAllData} className="ecf-box-donate__btn ecf-btn ecf-btn-primary" aria-label="donate-submit-button">{title_btn}</button>
        <div className="ecf-box-donate__description" dangerouslySetInnerHTML={{__html: description_form}} />
      </div>
		)
	}
}
export default ListItem;